import { Typography } from '@repo/ui';
import { InsightMetric } from 'types/Insights';
import styles from './SubMetricDetail.module.css';

export const InsightBreadcrumbs = ({
  subMetric,
}: {
  subMetric?: InsightMetric;
}) => {
  if (!subMetric) return <></>;
  return (
    <div className={styles.breadcrumbs}>
      <Typography variant='body-s'>
        {
          subMetric.gut_vaginal_health?.key_insights_category
            ?.key_insights_sections?.display_title
        }
      </Typography>
      <Typography variant='body-s'>
        ({subMetric?.gut_vaginal_health?.key_insights_category?.category_title})
      </Typography>
    </div>
  );
};
